import { all } from 'redux-saga/effects';
import masonListener from './mason/masonListener';

export default function*(action) {
    yield all([masonListener()]);
}